import React, { useState, useEffect } from "react";
import { DateRangePicker, Header } from "../../../components/ui";
import PageLayout from "../../../components/layout/PageLayout";
import { FaChartBar } from "react-icons/fa";
import api from "../../../services/api";
import DocumentCard from "./DocumentCard";

const allowedStatuses = ["ожидает", "в обработке", "обработан", "отменен"];

const DocumentPage = () => {
  const [range, setRange] = useState({ from: "", to: "" });
  const [documents, setDocuments] = useState([]);
  const [filteredDocs, setFilteredDocs] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filterBy, setFilterBy] = useState("server_received_at");
  const [statusFilter, setStatusFilter] = useState(""); // ← 🔥 новый фильтр

  const fetchDocuments = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get(`/externaltokens/documents`, {
        params: {
          startDate: range.from,
          endDate: range.to,
          filterBy,
        },
      });

      const docs =
        response?.documents ||
        response?.data?.documents ||
        response ||
        [];

      if (!Array.isArray(docs)) {
        setError("Некорректный формат ответа сервера");
        setDocuments([]);
      } else {
        setDocuments(docs);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  // 🔥 Фильтрация по статусу — КЛИЕНТСКАЯ
  useEffect(() => {
    if (!statusFilter) {
      setFilteredDocs(documents);
    } else {
      setFilteredDocs(
        documents.filter((doc) => doc.document_status === statusFilter)
      );
    }
  }, [statusFilter, documents]);

  useEffect(() => {
    if (range.from && range.to) {
      fetchDocuments();
    }
  }, [range, filterBy]);

  // 🔥 Удаление документа локально
  const handleDelete = (id) => {
    setDocuments((prev) => prev.filter((d) => d.document_id !== id));
  };

  return (
    <PageLayout
      header={
        <Header
          icon={FaChartBar}
          title="Документы"
          subtitle="Получение документов по датам"
        />
      }
      controls={<DateRangePicker mode="range" onChange={setRange} />}
      stats={
        <div style={{ display: "flex", gap: "10px" }}>
          {/* Фильтр по дате */}
          <select
            value={filterBy}
            onChange={(e) => setFilterBy(e.target.value)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          >
            <option value="document_date">Искать по дате документа</option>
            <option value="server_received_at">Искать по дате получения</option>
          </select>

          {/* 🔥 Фильтр по статусу */}
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          >
            <option value="">Все статусы</option>
            {allowedStatuses.map((st) => (
              <option key={st} value={st}>
                {st}
              </option>
            ))}
          </select>
        </div>
      }
    >
      <h1>Документы по датам</h1>

      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p>Загрузка...</p>}

      {!loading && !error && filteredDocs.length > 0 && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(330px, 1fr))",
            gap: "20px",
          }}
        >
          {filteredDocs.map((doc) => (
            <DocumentCard
              key={doc.document_id}
              document={doc}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}

      {!loading && !error && filteredDocs.length === 0 && (
        <p>Нет документов за выбранные параметры.</p>
      )}
    </PageLayout>
  );
};

export default DocumentPage;
